import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import { useParams } from 'react-router';

export const SttFodlesCreateModalShow = ({ open, onClose, reload, currentItem, closeform, }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const { id } = useParams()
    const NewDocumentSchema = Yup.object().shape({

    });

    const defaultValues = useMemo(
        () => ({

            file: currentItem?.file || 'None',

        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('description', data.description);
        formData.append('type', data.type);
        try {
            const response = await postRequest(
                `${endpoints.admin_dashboard.teachnical_database.stt_folders.show_list_create}/${id}/stt-topics`,
                // currentItem?.id
                //  `${endpoints.accounting.documents.post_request}/${currentItem.id}?_method=PUT`
                formData,
                true
            );
            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });



    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Saftey Toolbox Talk Topic Edit &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    <Box
                        mt={ 1 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(2, 2fr)',
                        } }
                    >
                        <RHFTextField name="name" label="Name" />
                        <RHFTextField name="type" label="Type" />
                    </Box>
                    <Box
                        mt={ 2 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(1, 1fr)',
                        } }
                    >
                        <RHFTextField name="description" label="Description" multiline rows={ 15 } />
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Create
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};